import reactLogo from '../assets/maple.png';

export default function Nav() {

    return (
        <div>
            <img src={reactLogo} className="logo" alt="Maple logo" />
            <h1 className='title'>枫之大陆 MapleLand</h1>
        </div>
    );
}